import api from '../api'

export default {
    namespaced: true,
    state: {
        mallChannelList: [],
        payList: []
    },
    mutations: {
        setStateMallChannelList(state, info) {
            state.mallChannelList = info
        },
        setStatePayList(state, info) {
            state.payList = info.map(item => {
                return {
                    label: item.paymentName,
                    value: `${item.paymentCode},${item.transType}`
                }
            });
            state.payList.unshift({
                label: '全部',
                value: ''
            });
        }
    },
    actions: {
        getMallChannelList({commit}) {
            return api.post('/mall/transtype/list', '商城支付通道配置列表').then(res => {
                commit('setStateMallChannelList', res.data)
            })
        },
        updateFirstStatus({dispatch}, params) {
            return api.post('/mall/transtype/priority/update', '优先推荐更新', params).then(() => {
                dispatch('getMallChannelList')
            })
        },
        updateUseStatus({dispatch}, params) {
            return api.post('/mall/transtype/use/update', '是否使用更新', params).then(() => {
                dispatch('getMallChannelList')
            })
        },
        updateSdkUseStatus({dispatch}, params) {
            return api.post('/mall/transtype/sdkUse/update', 'sdk是否可以用', params).then(() => {
                dispatch('getMallChannelList')
            })
        },
        getMallChannelDetail(store, params) {
            return api.post('/mall/transtype/query', '根据支付通道id查询内容', params)
        },
        updateMallChannelDetail(store, params) {
            return api.post('/mall/transtype/products/update', '更新支付通道名称和商品', params)
        },
        getPayList({commit}, params) {
            return api.post('/mall/transtype/pay/list', '支付SDK列表', params).then(res => {
                commit('setStatePayList', res.data)
            })
        },
    }
}